<aside
  class="sidebar"
  id="sidebar"
  [class.sidebar-is-collapsed]="collapsed"
  [attr.aria-expanded]="!collapsed">
  <nav class="sidebar-nav scrollbar-hide" aria-label="Modules">
    @for (group of navMenu; track group.group) {
      <div class="nav-group">
        <p class="nav-group-label">{{ group.group }}</p>
        @for (item of group.items; track item.href) {
          <button
            type="button"
            class="nav-item"
            [class.active]="isActive(item.href)"
            (click)="navigate(item.href)"
            (pointerenter)="onItemPointerEnter($event, item)"
            (pointerleave)="onItemPointerLeave()"
            (focus)="onItemFocus($event, item)"
            (blur)="onItemBlur()"
            [attr.aria-current]="isActive(item.href) ? 'page' : null"
            [attr.aria-label]="collapsed ? item.label : null"
            [attr.title]="collapsed ? null : item.label">
            <dmp-icon [name]="item.icon" size="md" />
            <span class="nav-label">{{ item.label }}</span>
          </button>
        }
      </div>
    }
  </nav>

  <div class="sidebar-foot">
    <div class="user-chip">
      <div class="u-meta">
        <div class="avatar sidebar-user-avatar" style="width:28px;height:28px">{{ displayInitials }}</div>
        <div class="sidebar-user-text">
          <div class="u-name">{{ displayName }}</div>
          <div class="u-role">{{ displayRole }}</div>
        </div>
      </div>
      <dmp-icon name="ops" size="sm" class="sidebar-user-settings" style="color:var(--muted-foreground)" />
    </div>
  </div>
</aside>

@if (collapsed && hoveredItem) {
  <div
    class="nav-flyout-panel"
    [class.active]="isActive(hoveredItem.href)"
    [style.top.px]="flyoutTop"
    role="tooltip"
    [attr.aria-label]="hoveredItem.label">
    <dmp-icon [name]="hoveredItem.icon" size="md" />
    <span>{{ hoveredItem.label }}</span>
  </div>
}
